import React from "react";

import moment from "moment";
import HistoryModal from "../../api/History";

import "../../styles/components/_history.scss";
import "../../styles/components/_table.scss";

const Table = ({ history, startDate, endDate, meta, fetchHistory }) => {
  const date_end = endDate.format("DD/MM/YYYY");
  const date_start = startDate.format("DD/MM/YYYY");

  if (history.length === 0) {
    return (
      <div className="support-history">
        <p className="form__alert">
          Sorry, there is no support history for the period: {date_start} –{" "}
          {date_end}
        </p>
      </div>
    );
  }

  return (
    <div className="support-history">
      <p className="history__summary">
        Showing results from {date_start} - {date_end}
      </p>
      <div className="table">
        <div className="table__wrap">
          <div className="table__header">
            <div className="table__heading table__item--date">Date</div>
            <div className="table__heading table__item--receipt">
              Receipt #{" "}
            </div>
            <div className="table__heading table__item--card">
              Payment Method
            </div>
            <div className="table__heading table__item--amount">
              <div className="table__sum">Amount</div>
            </div>
            <div className="table__heading table__item--print" />
          </div>
          {history.map((item, i) => (
            <TableRow key={i} item={item} />
          ))}
          <TablePagination
            {...meta}
            startDate={startDate}
            endDate={endDate}
            fetchHistory={fetchHistory}
          />
        </div>
      </div>
    </div>
  );
};

const TableRow = ({ item }) => {
  const { banked_at, receipt_no, payment_detail, amount_credit, amount_debit } =
    item;

  const negClass = amount_credit ? " is_negative" : "";
  const human_date = moment(banked_at).format("DD/MM/YYYY");
  return (
    <div className={`table__row ${negClass}`}>
      <div className="table__item table__item--date">{human_date} </div>
      <div className="table__item table__item--receipt">{receipt_no} </div>
      <div className="table__item table__item--card">{payment_detail}</div>
      <div className={`table__item table__item--amount ${negClass}`}>
        <div className="table__sum">
          {amount_credit ? "-" : ""} $ {amount_credit || amount_debit}{" "}
        </div>
      </div>
      <div className="table__item table__item--print">
        <button
          onClick={() => {
            HistoryModal.getRecieptReport(receipt_no);
          }}
          className="table__print"
        >
          Print
        </button>
      </div>
    </div>
  );
};

const TablePagination = ({ links, startDate, endDate, fetchHistory }) => {
  const navigate = (page) => {
    fetchHistory(startDate, endDate, page);
  };

  return (
    <div colSpan="5" className="pagination table__row">
      {links.map((link) => {
        const isActive = link.active;
        const isDisabled = isActive || !link.url;
        const className = isActive ? "active" : isDisabled ? "disabled" : "";

        return isDisabled ? null : (
          <div
            disabled={isDisabled}
            onClick={() => navigate(link.url.split("page=").pop())}
            class={className}
          >
            {link.label.replace("&laquo;", "«").replace("&raquo;", "»")}
          </div>
        );
      })}
    </div>
  );
};

export default Table;
